import { API_ORIGIN } from '@/constants'

export type SignupPolicy = {
  mode: 'open' | 'waitlist' | 'approval' | 'invite_only' | string
  require_approval: boolean
}

export type SignupHoldStatus = {
  approval_pending: boolean
  approval_rejected: boolean
}

export async function fetchSignupPolicy(): Promise<SignupPolicy> {
  const response = await fetch(`${API_ORIGIN}/api/accounts/signup/policy`)
  if (!response.ok) {
    throw new Error('Failed to load signup policy')
  }
  return response.json()
}

export async function fetchSignupHoldStatus(email: string): Promise<SignupHoldStatus> {
  const search = new URLSearchParams({ email: email.trim().toLowerCase() })
  const response = await fetch(`${API_ORIGIN}/api/accounts/signup/hold-status?${search.toString()}`)
  if (!response.ok) {
    return { approval_pending: false, approval_rejected: false }
  }
  return response.json()
}
